// extracted by mini-css-extract-plugin
module.exports = {"wallets":"Wallets_wallets__c7fYL","walletImage":"Wallets_walletImage__ESpwH","walletBg2":"Wallets_walletBg2__wzaHU","walletBg":"Wallets_walletBg__tpOIH"};